export default {
  methods: {
    createRequest () {
      this.editing = false

      this.stockRequest = Object.assign(this.stockRequest, {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          group: '',
          group_name: '',
          group_code: '',
          origin: '',
          origin_name: '',
          origin_code: ''
        },
        delivery_details: {
          customer_direct: 0,
          customer: '',
          mobile_number: '',
          address: ''
        },
        schedule_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: Array.from({ length: 5 }).map(
          () => ({
            product: null,
            quantity: null
          })
        ),
        remarks: ''
      })

      this.getOrigins(this).finally(() => {
        this.getProducts(this)
      })

      this.$bvModal.show('modalRequest')
    },

    submitRequest (remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srPending.create({
        id: id,
        origin: headers.origin,
        customer_direct: delivery_details.customer_direct,
        remarks: remarks,
        delivery_details: {
          customer: delivery_details.customer,
          mobile_number: delivery_details.mobile_number,
          address: delivery_details.address
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        active: 1
      }).then(() => {
        this.currentTabIndex = 0
      }).catch(
        errors => {
          if (errors.errors) {
            if (this.$refs.formStockRequest) {
              this.$refs.formStockRequest.setErrors({
                'headers.origin': errors.errors?.origin || [],
                'headers.category': errors.errors?.category || [],
                'headers.customer_direct': errors.errors?.customer_direct || []
              })
            }

            this.setProductErrors(errors.errors)
            this.$refs.formCustomer.setErrors(errors.errors)
          }
        }
      )
    }
  }
}
